export default [
    () => {
        return {
            restrict: "EA",
            require: "^appPick",
            replace: true,
            scope: {
                title: "@",
                search: "&",
                searchPlaceholder: "@",
                disabled: "="
            },
            template: `<div class="ws-pick-origin">
            <div class="ws-pick-title">
                <p>{{title}}</p>    
                <a ng-if="!disabled" ng-click="toggleAll()">全选</a>
            </div>
            <div class="ws-pick-body">
              <div class="ws-pick-search" ng-if="hasSearchFn">
                  <input type="text" placeholder="{{searchPlaceholder}}" ng-model="param.searchValue">
              </div>
              <div class="ws-pick-list">
                <ul>
                    <li ng-repeat="item in data">
                        <nk-checkbox class="nk-checkbox-success" ng-disabled="disabled" ng-model="param.choose" value="item.value">{{item.view}}</nk-checkbox>
                    </li>
                </ul>
              </div>
            </div>
        </div>`,
            link: ($scope, $element, $attr, ctrl) => {
                let originalData = [];

                let searchValue = "";

                $scope.param = {};

                $element[0].removeAttribute("title");

                $scope.data = [];

                $scope.param.choose = [];

                $scope.hasSearchFn = !!$attr.search;

                $scope.toggleAll = () => {
                    if ($scope.param.choose.length === $scope.data.length) {
                        $scope.param.choose = [];
                    } else {
                        $scope.param.choose = $scope.data.map((item) => item.value);
                    }
                };

                $scope.$watch(
                    "param.choose",
                    (newVal) => {
                        ctrl.setCheckOrigin(newVal);
                    },
                    true
                );

                $scope.$watch(
                    "param.searchValue",
                    (newVal, oldValue) => {
                        searchValue = newVal;
                        if (newVal !== oldValue) {
                            const data = $scope.search({ input: newVal, data: getOriginArray(originalData) });
                            $scope.data = ctrl.convert(data);
                        }
                    },
                    true
                );

                ctrl.listenOriginChange((data) => {
                    originalData = angular.copy(data);
                    $scope.$evalAsync(() => {
                        $scope.param.choose = [];
                        $scope.data = searchValue
                            ? ctrl.convert($scope.search(searchValue, getOriginArray(originalData)))
                            : data;
                    });
                });

                function getOriginArray(array: any[]): any[] {
                    return array.map((item) => {
                        return item.origin;
                    });
                }
            }
        };
    }
];
